import React, { useCallback, useEffect } from 'react';
import { Grid, IconButton } from '@mui/material';

interface VideoThumbnailsProps {
  allUrls: string[];
  onSelectVideo: (url: string) => void;
  selectedVideo: string;
}

const VideoThumbnails: React.FC<VideoThumbnailsProps> = ({
  allUrls,
  onSelectVideo,
  selectedVideo
}) => {
  const handleKeyDown = useCallback(
    (event: KeyboardEvent) => {
      const currentIndex = allUrls.indexOf(selectedVideo);
      if (event.key === 'ArrowRight') {
        const newIndex =
          currentIndex + 1 < allUrls.length ? currentIndex + 1 : 0;
        onSelectVideo(allUrls[newIndex]);
      } else if (event.key === 'ArrowLeft') {
        const prevIndex =
          currentIndex - 1 >= 0 ? currentIndex - 1 : allUrls.length - 1;
        onSelectVideo(allUrls[prevIndex]);
      }
    },
    [allUrls, onSelectVideo, selectedVideo]
  );
  useEffect(() => {
    const handleComponentFocus = () => {
      window.addEventListener('keydown', handleKeyDown);
    };

    handleComponentFocus();

    return () => {
      window.removeEventListener('keydown', handleKeyDown);
    };
  }, [handleKeyDown]);

  return (
    <div tabIndex={0} style={{ outline: 'none' }}>
      <Grid
        container
        spacing={1}
        sx={{
          padding: 4,
          maxHeight: '150px',
          overflow: 'auto',
          justifyContent: 'center'
        }}
      >
        {allUrls.map((url, index) => (
          <Grid item key={index} xs={4} sm={2} md={1}>
            <IconButton onClick={() => onSelectVideo(url)} size="large">
              <video
                style={{
                  width: '50px',
                  height: '50px',
                  borderRadius: '2px',
                  border: url === selectedVideo ? '2px solid black' : 'none'
                }}
                src={url}
                loop
                muted
                onClick={() => onSelectVideo(url)}
              />
            </IconButton>
          </Grid>
        ))}
      </Grid>
    </div>
  );
};

export default VideoThumbnails;
